import { HERO_IMAGE } from "@/data/services";
import { GALLERY_HERO_IMAGE } from "@/data/gallery";

export const WP_API_URL = "https://wewonderevents.com/wp-json/wp/v2";

export const DEFAULT_SETTINGS = {
  contact_url: "/contact",
  phone_1: "+91 9953132218",
  phone_2: "+91 9861307147",
  email: "contact2wonderevents@gmail.com",
  address:
    "N-5/20, Ground Floor, Near TPCODL Office, IRC Village, Nayapalli, Bhubaneswar, Odisha – 751015",
  working_hours: "Mon – Sat @ 9:00 AM – 7:00 PM",
  header_button_text: "Plan Your Event",
  footer_description:
    "Creating unforgettable experiences through innovative event planning, flawless execution, and creative excellence. We transform ideas into memorable celebrations across India.",
  services_hero_eyebrow: "What We Do",
  services_hero_heading: "Creating Experiences|That Inspire",
  services_hero_text:
    "From corporate and government events to unforgettable celebrations, we bring creativity, innovation and precision to every experience.",
  services_hero_image: HERO_IMAGE,
  services_hero_button: "Let’s Plan Your Event",
  intro_heading: "Our Expertise",
  intro_text:
    "From concept to execution, we bring every detail together to create seamless, memorable events that leave a lasting impression. With extensive experience across corporate, government, entertainment, creative, digital and social events, Wonder Events delivers innovative solutions tailored to every requirement.",
  services_section_eyebrow: "Our Services",
  services_section_heading: "Six Pillars of Excellence",
  services_section_text:
    "Explore our complete range of event, creative and digital services — each delivered with precision, passion and professionalism.",
  whatwedo_eyebrow: "What We Do",
  whatwedo_heading: "Every Detail, Beautifully Executed",
  whatwedo_text:
    "From concept to execution, we bring every detail together to create seamless, memorable events that leave a lasting impression.",
  whychoose_eyebrow: "Why Choose Us",
  whychoose_heading: "Why Choose Wonder Events?",
  approach_eyebrow: "Our Approach",
  approach_heading: "From Vision to Reality",
  cta_heading: "Ready to Create Something Extraordinary?",
  cta_text: "Let’s turn your vision into an unforgettable experience.",
  cta_button: "Let’s Plan Your Event",
  gallery_hero_eyebrow: "Our Gallery",
  gallery_hero_heading: "Photo|Gallery",
  gallery_hero_text:
    "Explore memorable moments from the events, celebrations and experiences we bring to life.",
  gallery_hero_image: GALLERY_HERO_IMAGE,
  albums_heading: "Event Albums",
  albums_text: "Browse our events album by album — every collection tells its own story.",
  gallery_cta_heading: "Let’s Create Something Wonderful",
  gallery_cta_text:
    "Have an event in mind? Let’s turn your vision into an unforgettable experience.",
  gallery_cta_button: "Plan Your Event",
  contact_hero_eyebrow: "Contact Us",
  contact_hero_heading: "Let’s Create Something|Wonderful",
  contact_hero_text:
    "Have an event in mind? Get in touch with our team and let’s bring your vision to life.",
  contact_hero_image: "https://wewonderevents.com/wp-content/uploads/2026/09/KOICA.jpeg",
  contact_intro_heading: "Let’s Talk About Your Event",
  contact_intro_text:
    "Whether you’re planning a corporate event, government or PSU programme, exhibition, entertainment experience or social celebration, we’re here to help. Share your requirements with us and our team will get back to you.",
  contact_form_title: "Tell Us About Your Event",
  contact_form_button: "Send Enquiry",
  findus_heading: "Find Us",
  contact_cta_heading: "Ready to Make Your Event Wonderful?",
  contact_cta_text: "Let’s turn your ideas into memorable experiences.",
  contact_cta_button: "Plan Your Event",
  form_endpoint: "https://wewonderevents.com/wp-json/contact-form-7/v1/contact-forms/23/feedback",
  web3forms_access_key: "",
  form_label_name: "Full Name",
  form_label_email: "Email Address",
  form_label_phone: "Phone Number",
  form_label_event_type: "Event Type",
  form_label_event_date: "Event Date",
  form_label_location: "Event Location",
  form_label_message: "Your Message",
  form_event_types:
    "Corporate Events, Government & PSU Events, Artists & Entertainment, Creative Solutions, Digital Solutions, Social Events, Other",
  form_success_heading: "Thank you for your enquiry!",
  form_success_text: "Our team will get back to you shortly.",
  get_directions_text: "Get Directions",
  footer_services:
    "Corporate Events, Government & PSU Events, Artists & Entertainment, Creative Solutions, Digital Solutions, Social Events",
  copyright_text: "© 2026 Wonder Events & Entertainment Pvt. Ltd. All Rights Reserved.",
  whatsapp_number: "919953132218",
  whatsapp_message: "Hi Wonder Events! I'd like to plan an event.",
};

export const Heading = ({ value, className, accentClass = "text-[#E05252]" }) => {
  const [main, accent] = (value || "").split("|");
  return (
    <span className={className}>
      {main}
      {accent ? <> <span className={accentClass}>{accent}</span></> : null}
    </span>
  );
};
